import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
declare var $: any;

@Component({
  selector: 'app-delete',
  templateUrl: './delete.component.html',
  styleUrls: ['./delete.component.scss']
})
export class DeleteComponent implements OnInit {


  @Input() id = 'delete-dialog';
  @Input() title = 'Are you sure?';
  @Input() description = 'Are you sure you want to delete record?';
  @Input() data: any;
  @Input() cancelButtonText = 'Cancel';
  @Input() confirmButtonText = 'Delete';

  @Output() onCancel: EventEmitter<any> = new EventEmitter<any>();
  @Output() onConfirm: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {
  }

  onCancelClicked() {
    setTimeout(() => {
      this.onCancel.emit(false);
      this.close();
    }, 50);
  }

  onConfirmClicked() {
    setTimeout(() => {
      this.onConfirm.emit(true);
      this.close();
    }, 50);
  }

  close() {
    $(`#${this.id}`).modal('hide');
  }

}
